module.exports = {
  ...require('./index.json'),
  featuredImage: require('./images/header.webp'),
};
